import { useMemo } from 'react';
import { useInfiniteQuery } from '@tanstack/react-query';
import { useLineOfBusiness } from './useLineOfBusiness';
import { useGetConversationsRequest } from '../api/useGetConversationsRequest';
import { Order, pipe, ReadonlyArray } from 'effect';
import { useShowChatboxStore } from '../stores/showChatboxStore';
const PAGE_SIZE = 3;
export const useReceiveHistory = () => {
    var _a;
    const { lineOfBusiness } = useLineOfBusiness();
    const [chatboxIsShown] = useShowChatboxStore(lineOfBusiness);
    const receiveHistoryRequest = useGetConversationsRequest(PAGE_SIZE);
    const queryResult = useInfiniteQuery({
        queryKey: ['history', lineOfBusiness],
        queryFn: ({ pageParam }) => receiveHistoryRequest({
            lineOfBusiness: lineOfBusiness,
            last: pageParam,
        }).then((result) => ({
            offset: pageParam,
            result,
        })),
        initialPageParam: 1,
        getNextPageParam: ({ offset }) => Math.max(0, offset - PAGE_SIZE),
        getPreviousPageParam: ({ offset, result }) => Math.min(result.getConversations.conversationsCount, offset + PAGE_SIZE),
        enabled: chatboxIsShown,
    });
    const events = useMemo(() => {
        var _a, _b;
        return pipe((_b = (_a = queryResult.data) === null || _a === void 0 ? void 0 : _a.pages) !== null && _b !== void 0 ? _b : [], pages => pages
            .flatMap(p => p.result.getConversations.conversationFeed)
            .filter(c => !c.isCurrent), ReadonlyArray.flatMap(feed => feed.events), ReadonlyArray.dedupeWith((a, b) => a.id === b.id), evs => evs.map((ev) => (Object.assign(Object.assign({}, ev), { local: false, readByCustomer: false, historic: true, loading: false, failed: false }))), ReadonlyArray.sortWith(ev => +ev.persistedTimestamp, Order.number));
    }, [(_a = queryResult.data) === null || _a === void 0 ? void 0 : _a.pages]);
    return Object.assign(Object.assign({}, queryResult), { data: events });
};
